import { render } from "./UserAgreementView.vue?vue&type=template&id=6e072db2&scoped=true"
import script from "./UserAgreementView.vue?vue&type=script&lang=js"
export * from "./UserAgreementView.vue?vue&type=script&lang=js"

import "./UserAgreementView.vue?vue&type=style&index=0&id=6e072db2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e072db2"]])

export default __exports__